import React from "react";
export const Checkbox = ({ label, isChecked = false, value, id, isMandatory = false, onChange }) => React.createElement("span", { className: "m35-checkbox" },
    React.createElement("label", null,
        React.createElement("input", { type: "checkbox", value: value || label, id: id, onChange: onChange, checked: isChecked }),
        label,
        isMandatory && "*",
        React.createElement("span", { className: "m35-checkbox__custom-checkbox" })));
